import { useTranslation } from "react-i18next";
import { ColumnItem } from "../../../../../../utils/types/generals";
import { Settings } from "../../../../../../components/settings";
import { useMenu } from "./menu";
import { BaseMenuClick } from "../../../../../../components/baseMenu";

export const useColumn = ({ click }: { click?: BaseMenuClick }): ColumnItem[] => {
    const menu = useMenu()
    const { t } = useTranslation()

    return [
        {
            id: 'date',
            sortable: true,
            label: t('general.service.areaDepartment.main.table.date'),
            headerCell: {
                width: '200px'
            }
        },
        {
            id: 'area',
            sortable: true,
            label: t('general.service.areaDepartment.main.table.area'),
        },
        {
            id: 'department',
            sortable: true,
            label: t('general.service.areaDepartment.main.table.department'),
        },
        {
            id: 'preventiveCatalog',
            sortable: true,
            label: t('general.service.areaDepartment.main.table.preventiveCatalog'),
        },
        {
            id: 'correctiveCatalog',
            sortable: true,
            label: t('general.service.areaDepartment.main.table.correctiveCatalog'),
        },
        {
            id: 'setting',
            label: '',
            renderCell: (params) => {
                return (
                    <Settings
                        row={params?.row}
                        rowLength={1}
                        menu={{
                            click: (item) => { if (click) { click(item, params?.row) } },
                            menuItems: menu
                        }}
                    />
                )
            }
        },
    ]
}